module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/buttons/subscribe-client-btn/subscribe-client-btn.scss
// module id = ./web/modern/components/buttons/subscribe-client-btn/subscribe-client-btn.scss
// module chunks = 0